import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { QueryParamItem, QueryParamsService } from '../../core/services/query-params.service';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FilterItem } from './filter-item.model';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'sha-filter-item',
  templateUrl: 'filter-item.component.html',
  styleUrls: ['filter-item.component.css']
})
export class FilterItemComponent implements OnInit, OnDestroy {

  @Output() changed: EventEmitter<FilterItem>;
  @Input() routeName = 'fitem';
  @Input() filterItems: FilterItem[] = [];

  currentFilterItem: BehaviorSubject<FilterItem> = new BehaviorSubject(null);
  subscription: Subscription;

  constructor(private queryParamsService: QueryParamsService) {
    this.changed = new EventEmitter<FilterItem>();
  }

  ngOnInit() {
    this.queryParamsService.observe(this.routeName).subscribe(item => this.filterItemChangedInRoute(item));
    this.subscription = this.currentFilterItem.subscribe(item => this.changed.emit(item));
  }

  ngOnDestroy() {
    this.queryParamsService.destroy(this.routeName);
    this.subscription.unsubscribe();
  }

  filterItemChanged(item: FilterItem) {
    // console.log('FilterItemComponent - filterItemChanged ->', item);

    const currentItem = this.currentFilterItem.getValue();
    if (!currentItem || currentItem.id !== item.id) {
      this.currentFilterItem.next(item);
    } else {
      this.currentFilterItem.next(null);
    }

    this.updateRoute();
  }

  filterItemChangedInRoute(queryParamItem: QueryParamItem) {
    // console.log('FilterItemComponent - filterItemChangedInRoute ->', queryParamItem, this.filterItems);
    const item = this.filterItems.find(filterItem => filterItem.id === queryParamItem.value);

    const currentValue = this.currentFilterItem.getValue();
    const itemUnselect = !item && currentValue;
    const newItemSelected = !currentValue || (item && currentValue.id !== item.id);
    if (itemUnselect || newItemSelected) {
      this.currentFilterItem.next(item);
    }
  }

  private updateRoute() {
    const param = {};
    const filter = this.currentFilterItem.getValue();
    param[this.routeName] = (filter) ? filter.id : '';
    // console.log('FilterItemComponent - updateRoute ->', filter, param);
    this.queryParamsService.navigateByQueryParams([param]);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-item/filter-item.component.ts